module.exports = __webpack_public_path__ + "img/Step3.645d4b1.svg";